import React from 'react';

const AppLoader = () => {
  return (
    <span className="fixed inset-0 w-screen h-screen flex items-center justify-center text-3xl z-50">yükleniyor</span>
  );
};

export default AppLoader;
